<template>
  <v-app>
    <v-main class="content mx-0 mx-md-2">
      <v-container>
          <v-row>
            <v-col cols="12" class="mt-16 d-flex align-center justify-center">
                <v-img
                  style="cursor:pointer"
                  @click="onClickLogo"
                  max-height="150"
                  max-width="280"
                  src="@/assets/img/logo.svg"
                ></v-img>
            </v-col>
          </v-row>
          <v-col cols="12" class="login-part d-flex align-center justify-center">
            <div class="login-wrapper pt-16 pt-sm-0">
              <v-tabs grow v-model="loginTabs" class="my-8" light>
                <v-tabs-slider></v-tabs-slider>
                <v-tab :href="`#tab-login`">
                  Вход
                </v-tab>
                <v-tab :href="`#tab-newUser`">
                  Регистрация
                </v-tab>

                <v-tab-item :value="'tab-login'" >
                  <v-form>
                    <v-container>
                      <v-row class="flex-column">
                        <v-col>
                          <p class="login-slogan display-2 text-center font-weight-medium my-5" style="font-size: 2.6rem !important;">Войдите в личный кабинет</p>
                          <!-- <v-btn
                            height="45"
                            light
                            block
                            color="white"
                            elevation="0"
                            class="google text-capitalize"
                            @click="googleLogin">
                            <v-img src="@/assets/google.svg" max-width="30" class="mr-4"></v-img>
                            Sign in with Google</v-btn> -->
                        </v-col>
                        <!-- <v-col cols="12" class="d-flex align-center my-3 my-sm-8">
                          <v-divider light></v-divider>
                          <span class="px-5 black--text"> or </span>
                          <v-divider light></v-divider>
                        </v-col> -->
                        <v-form
                          id="login-form"
                          ref="log"
                          v-model="valid"
                          lazy-validation
                        >
                          <v-col>
                            <v-text-field
                              light
                              id="email"
                              ref="email"
                              v-model="email"
                              :rules="emailRules"
                              value=""
                              label="Email"
                              placeholder="Email"
                              persistent-placeholder
                              outlined
                              required
                            ></v-text-field>
                            <v-text-field
                              light
                              :append-icon="showPassLogin ? 'mdi-eye' : 'mdi-eye-off'"
                              :type="showPassLogin ? 'text' : 'password'"
                              @click:append="showPassLogin = !showPassLogin"
                              id="password"
                              ref="password"
                              v-model="password"
                              :rules="[v => !!v || 'Поле обязательно для заполнения',]"
                              outlined
                              label="Пароль"
                              placeholder="Пароль"
                              persistent-placeholder
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col class="d-flex justify-space-between">
                            <v-btn
                              class="text-capitalize"
                              large
                              :disabled="!valid"
                              color="primary"
                              :loading="isFetching"
                              @click="login">
                              Войти
                            </v-btn>
                            <v-btn
                              @click="forgotPassword"
                              large
                              text
                              class="text-capitalize primary--text">
                              Восстановить пароль
                            </v-btn>
                            <v-btn 
                              v-if="isShowRetryConfirmBtn"
                              @click="onRetryConfirm"
                              large
                              text
                              class="text-capitalize primary--text">
                                Подтвердить email
                            </v-btn>
                          </v-col>
                        </v-form>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-tab-item>

                <v-tab-item :value="'tab-newUser'" >
                  <v-form>
                    <v-container>
                      <v-row class="flex-column">

                        <v-col>
                          <p class="login-slogan display-2 text-center font-weight-medium mt-10">Регистрация</p>
                          <p class="login-slogan display-1 text-center font-weight-medium mb-10"></p>
                        </v-col>

                        <v-form ref="formRegistration" lazy-validation v-model="registerFormValid">
                          <v-col>
                            <v-text-field
                              placeholder="Как Вас зовут"
                              persistent-placeholder
                              light
                              v-model="createFullName"
                              outlined
                              label="Ваше имя"
                              :rules="[v => !!v || 'Поле обязательно для заполнения']"
                              required
                            ></v-text-field>
                            <v-text-field
                              light
                              v-model="createEmail"
                              :rules="emailRules"
                              outlined
                              label="Email"
                              placeholder="Email"
                              persistent-placeholder
                              required
                            ></v-text-field>
                            <v-text-field
                              light
                              v-model="createPassword"
                              :append-icon="showPassRegister ? 'mdi-eye' : 'mdi-eye-off'"
                              :type="showPassRegister ? 'text' : 'password'"
                              @click:append="showPassRegister = !showPassRegister"
                              @input="onValidateConfirmPass"
                              :rules="passRules"
                              outlined
                              label="Пароль"
                              placeholder="Пароль"
                              persistent-placeholder
                              hint=""
                              required
                            ></v-text-field>
                            <v-text-field
                              class="mb-0"
                              ref="confirm"
                              light
                              v-model="createPasswordConfirm"
                              :rules="[v => this.createPasswordConfirm === this.createPassword || 'Пароли не совпадают', ...passRules]"
                              outlined
                              :type="showPassRegister ? 'text' : 'password'"
                              label="Подтвердить пароль"
                              placeholder="Подтвердить пароль"
                              persistent-placeholder
                              hint=""
                              required
                            ></v-text-field>
                            <v-checkbox
                              class="mt-0"
                              v-model="checkbox"
                              :rules="[v => !!v || 'Подтвердите согласие для продолжения регистрации']"
                              required
                            >
                              <template v-slot:label>
                                <div>
                                  Даю 
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <a
                                        target="_blank"
                                        href="https://ais24.ru/legal/%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%81%D0%B8%D0%B5_%D0%BD%D0%B0_%D0%BE%D0%B1%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BA%D1%83_%D0%BF%D0%B5%D1%80%D1%81%D0%BE%D0%BD%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D1%85_%D0%B4%D0%B0%D0%BD%D0%BD%D1%8B%D1%85_%D0%90%D0%98%D0%A124.pdf"
                                        @click.stop
                                        v-on="on"
                                      >
                                      согласие
                                      </a>
                                    </template>
                                    Посмотреть политику обработки
                                  </v-tooltip>
                                  на обработку персональных данных согласно политике обработки
                                </div>
                              </template>
                            </v-checkbox>
                          </v-col>
                          <v-col class="d-flex justify-space-between">
                            <v-btn
                              light
                              large
                              block
                              :disabled="!isValidFormRegistration"
                              color="primary"
                              :loading="regIsFetching"
                              @click="register">Создать аккаунт</v-btn>
                          </v-col>
                          <v-alert
                            colored-border
                            type="info"
                            elevation="2"
                            style="font-size:14px"
                          >
                            Нажимая кнопку "Создать Аккаунт" Вы принимаете условия 
                            <a href="https://ais24.ru/legal/Пользовательское_соглашение_АИС24.pdf" target="_blank">пользовательского соглашения</a>
                          </v-alert>
                        </v-form>

                        <!-- <v-col cols="12" class="d-flex align-center my-2 my-sm-8">
                          <v-divider light></v-divider>
                          <span class="px-5 black--text"> or </span>
                          <v-divider light></v-divider>
                        </v-col>

                        <v-btn light @click="googleLogin" height="45" block color="white" elevation="0" class="google text-capitalize">
                          <v-img src="@/assets/google.svg" max-width="30" class="mr-4"></v-img>
                          Sign in with Google</v-btn> -->
                      </v-row>
                    </v-container>
                  </v-form>
                </v-tab-item>
              </v-tabs>
            </div>
          </v-col>
          <v-col cols="12" class="d-flex align-center justify-center">
            <v-footer>
              <div class="primary--text">© {{new Date().getFullYear()}} ООО "ЖКХ-Онлайн" все права защищены</div>
            </v-footer>
          </v-col>
      </v-container>
      <notification></notification>
    </v-main>
  </v-app>
</template>

<script>
import Notification from '@/app/components/Notification';
import { mapState, mapActions } from 'vuex'
import config from "../../config";
export default {
  name: 'Login',
  components: {Notification},
    props:{
        initLoginTabs:{
            default: '',
            type: String
        }
    },
    created() {
      this.loginTabs = this.initLoginTabs;
    },
  data() {
    return {
      checkbox: false,
      isActivateLoginBtn: true,
      isActiveRetryConfirmBtn: true,
      showPassLogin: false,
      showPassRegister:false,
      valid: true,
      loginTabs: '',
      email: '',
      password: '',
      registerFormValid: false,
      createFullName: '',
      createEmail: '',
      createPassword: '',
      createPasswordConfirm: '',
      emailRules: [
        v => !!v || 'Поле обязательно для заполнения',
        v => /.+@.+/.test(v) || 'Укажите дейсвительный email',
        // v => v.toLowerCase() === this.email
      ],
      passRules: [
        v => !!v || 'Поле обязательно для заполнения',
        v => /(?=.*[0-9])(?=.*[а-яa-z])(?=.*[А-ЯA-Z])/.test(v) || 'Требования к паролю: Буквы на кириллице или латинице, минимум одна прописная и одна заглавная, минимум одно число. Пароль должен содержать не менее 8 символов.',
        v => v.length >= 8 || 'Минимальная длина 8 символов',
      ],
    }
  },
  methods: {
    ...mapActions('register', ['registerUser', 'registerError']),
    ...mapActions('auth', ['loginUser', 'receiveToken', 'receiveLogin', 'disableRetryConfirm', 'checkAuth']),
    ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR']),
    onClickLogo(){
      window.location.href = '/';
    },

    showErrorMessage(message)
    {
      this.SHOW_ERROR({message, timeout: 10000});
    },
    showSuccessMessage(message)
    {
      this.SHOW_SUCCESS({message, timeout: 7000});
    },

    onValidateConfirmPass(){
      this.$refs.confirm.validate()
      
    },
    async login(){
      if(!this.$refs.log.validate()){
        return;
      }
      const email = this.email;
      const password = this.password;
      try {
        await this.loginUser({email, password});
        if(this.checkAuth()){
          this.$router.push({name: 'Main'});
        }
      }catch (e) {
        console.log(e);
      }
    },
    onRetryConfirm(){
        this.$router.push({name: 'RetryConfirm', params: {email:this.email}});
    },

    forgotPassword(){
      this.$router.push({name: 'ForgotPassword', params: {email:this.email}});
    },
    register() {
      const isValid = this.$refs.formRegistration.validate();
      if(!isValid){
          return;
      }
      let data = {
        email: this.createEmail,
        name: this.createFullName,
        password: this.createPassword,
        password_confirmation: this.createPasswordConfirm,
      };
      this.registerUser(data);
    },
    validate(){
      if (this.$refs.log.validate()) {
        window.localStorage.setItem('authenticated', true);
        this.$router.push('/user/profile');
      }
    },
  },
  computed: {
    isValidFormRegistration(){
        return this.registerFormValid === true;
    },
    ...mapState('auth', {
      isFetching: state => state.isFetching,
      errorMessage: state => state.errorMessage,
      isShowRetryConfirmBtn: state => state.isRetryConfirm,
    } ),
    ...mapState('register', {
      regIsFetching: state => state.isFetching,
      regErrorMessage: state => state.errorMessage,
      regSuccess: state => state.success,
      regSuccessMessage: state => state.message,
    } ),
  },

  watch: {
    regSuccess(){
      if( this.regSuccess === false ){
        return;
      }
      this.email = this.createEmail;
      this.password = this.createPassword;
      this.showSuccessMessage(this.regSuccessMessage);
      setTimeout(() => {
        this.loginTabs = 'tab-login';
      }, 2000)
    },
    errorMessage() {
      if(this.errorMessage == null || this.errorMessage === ""){
        return;
      }
      this.showErrorMessage(this.errorMessage);
    },
    regErrorMessage() {
      if(this.regErrorMessage === ''){
        return;
      }
      this.showErrorMessage(this.regErrorMessage);
    }
  },
  mounted() {
    if(config.isDevMode){
      // const creds = config.auth;
      // this.email = creds.email;
      // this.password = creds.password;
    }
    setTimeout(() => {
      this.$metrika.hit(window.location.href);
    }, 1000)
  }
}

</script>

<style src="./Login.scss" lang="scss"/>
